import { render } from "./register-confirm.vue?vue&type=template&id=15eac406"
import script from "./register-confirm.vue?vue&type=script&lang=js"
export * from "./register-confirm.vue?vue&type=script&lang=js"

import "./register-confirm.vue?vue&type=style&index=0&id=15eac406&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__